import GoldPriceTypes from './gold-price-report.types';

/** ***************** FETCH GOLD PRICE DETAILS START *********************** */
export const getGoldUpdateLogStart = (fetchData: any) => ({
	type: GoldPriceTypes.GET_GOLD_UPDATE_LOG_REPORT_START,
	payload: fetchData,
});

export const getGoldUpdateLogSucess = (successData: any) => ({
	type: GoldPriceTypes.GET_GOLD_UPDATE_LOG_REPORT_SUCCESS,
	payload: successData,
});

export const getGoldUpdateLogFailure = (failureData: any) => ({
	type: GoldPriceTypes.GET_GOLD_UPDATE_LOG_REPORT_FAILURE,
	payload: failureData,
});

export const getGoldUpdateLogResponseReset = () => ({
	type: GoldPriceTypes.GET_GOLD_UPDATE_LOG_REPORT_RESPONSE_RESET,
});

export const getGoldUpdateLogResponseChanged = () => ({
	type: GoldPriceTypes.GET_GOLD_UPDATE_LOG_REPORT_RESPONSE_CHANGED,
});

/** ***************** FETCH GOLD PRICE DETAILS END *********************** */
